import { Adapter as o } from "../../../../adapter.js";
import { CheckoutSettingsConfigurationModel as t } from "./configuration.model.js";
class a extends o {
  adapt(e) {
    return new t({
      analytics: e.analytics,
      headCode: e.head_code,
      bodyCode: e.body_code,
      supportedLanguages: e.supported_languages
    });
  }
  serialize(e) {
  }
}
export {
  a as CheckoutSettingsConfigurationAdapter
};
//# sourceMappingURL=configuration.adapter.js.map
